import { Component, Injectable, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Test9State } from '../../../store/reducers/test9.reducers';

import { Movie } from '../../../../src/models/movie';

import * as fromSelectors from '../../../store/selectors/test9.selectors';
import * as fromActions from '../../../store/actions/test9.actions';
import { MsgToUser } from 'libs/shared-lib1/src/lib/msgs-to-user/models/MsgToUser.model';
import { MsgsToUserService } from 'libs/shared-lib1/src/lib/msgs-to-user.service';

@Component({
  selector: 'test9-movie-list',
  templateUrl: './test9-movie-list.component.html',
  styleUrls: ['./test9-movie-list.component.scss']
})

@Injectable()
export class Test9MovieListComponent implements OnInit {

  movies$!: Observable<Movie[] | undefined>;
  movies: Movie[];

  selectedIndex: number = null;
  earning = 0;

  showLoading$: Observable<boolean | undefined>;
  showLoading: boolean;

  error$: Observable<string | undefined>;
  error: string;

  constructor(
    private store: Store<Test9State>,
    private msgsToUserService: MsgsToUserService) { }

  ngOnInit(): void {

    this.setupSelectors();
    this.setupSubs();
    this.dispatch();
  }


  setupSelectors() {

    this.movies$ = this.store.select(fromSelectors.selectMovies);

    this.showLoading$ = this.store.select(fromSelectors.selectLoading);

    this.error$ = this.store.select(fromSelectors.selectError);

  }

  setupSubs() {

    this.movies$.subscribe((moviesArray: any) => {

      if (moviesArray.length > 0) {

        this.movies = moviesArray;

      }

    });

    this.showLoading$.subscribe(w => {

      this.showLoading = w;

    })

    this.error$.subscribe(w => {

      if(w != "") {


        this.error = w;
        //alert("error" + w)

        const msg ="error in the api call...";
        const color = "red";

        const msgToUser: MsgToUser = new MsgToUser(msg, color);

        this.msgsToUserService.setMsgsToUser(msgToUser);

      }

    })
  }

  dispatch() {

    this.store.dispatch(fromActions.loadMovies());

  }

  enableEdit(movie: Movie, index: number): void {

    this.selectedIndex = index;
    this.earning = movie.Earning;

  }

  cancelEdit(): void {

    this.selectedIndex = null;

  }

  //https://www.youtube.com/watch?v=px9FXFN-yTk&list=PL4cSPhAvl8xUOt7RrCPEwzVPs8RXWsGzg&index=9&ab_channel=FunOfHeuristic
  //12:24
  // update the earning from the input then dispatch update action
  update(movie: Movie): void {

    const m = { ...movie };

    m.Earning = this.earning;

    this.store.dispatch(fromActions.updateMovie(m));

    this.selectedIndex = null;

  }

  deleteMovie(movieId: number): void {

    this.store.dispatch(fromActions.deleteMovie({ movieId: movieId}));

  }

  ngOnDestroy(): void {


  }

}
